import { render, staticRenderFns } from "./WeekPlanTab.vue?vue&type=template&id=315a4ab1&"
import script from "./WeekPlanTab.vue?vue&type=script&lang=js&"
export * from "./WeekPlanTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports